import "../styles/notification-panel.scss";
import { useSelector } from "react-redux";
import actions from "../actions/actions";
import navigate from "../utilities/navigation";
import { Path } from "../utilities/constants";

function timeAgo(dateStr) {
  const diff = Math.floor(
    (Date.now() - new Date(dateStr + "Z").getTime()) / 1000,
  );
  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export default function NotificationPanel({ onClose }) {
  const items = useSelector((store) => store.inAppNotifications.items);
  const unreadCount = useSelector(
    (store) => store.inAppNotifications.unreadCount,
  );

  async function handleItemClick(notification) {
    if (!notification.isRead) {
      await actions.inAppNotifications.markRead(notification.id);
    }
    onClose();
    navigate(`${Path.AlertDetails}?id=${notification.alertId}`);
  }

  async function handleMarkAllRead() {
    if (unreadCount === 0) return;
    await actions.inAppNotifications.markAllRead();
  }

  return (
    <div className="notif-panel">
      <div className="notif-panel__header">
        <span className="notif-panel__title">Notifications</span>
        {unreadCount > 0 && (
          <button className="notif-panel__mark-all" onClick={handleMarkAllRead}>
            Mark all as read
          </button>
        )}
      </div>

      <div className="notif-panel__list">
        {items.length === 0 ? (
          <div className="notif-panel__empty">
            <i className="fas fa-bell-slash" />
            <span>No notifications yet</span>
          </div>
        ) : (
          items.map((n) => (
            <div
              key={n.id}
              className={`notif-panel__item${n.isRead ? "" : " notif-panel__item--unread"}`}
              onClick={() => handleItemClick(n)}
            >
              <div className="notif-panel__item-icon">
                <i className="fas fa-bell" />
              </div>
              <div className="notif-panel__item-content">
                <span className="notif-panel__item-title">{n.title}</span>
                <span className="notif-panel__item-body">{n.body}</span>
                <span className="notif-panel__item-time">
                  {timeAgo(n.createdAt)}
                </span>
              </div>
              {!n.isRead && <div className="notif-panel__unread-dot" />}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
